import { createContext, useContext, useEffect, useMemo, useState } from "react";
import { PRODUCTS } from "@/data/products";

const CartContext = createContext(null);
const STORAGE_KEY = "vapour01_cart";

export const CartProvider = ({ children }) => {
  const [items, setItems] = useState(() => {
    try {
      return JSON.parse(localStorage.getItem(STORAGE_KEY)) || [];
    } catch {
      return [];
    }
  });
  const [isOpen, setIsOpen] = useState(false);

  useEffect(() => {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(items));
  }, [items]);

  const addItem = (slug) => {
    setItems((prev) => {
      const existing = prev.find((i) => i.slug === slug);
      if (existing) {
        return prev.map((i) => (i.slug === slug ? { ...i, qty: Math.min(i.qty + 1, 20) } : i));
      }
      return [...prev, { slug, qty: 1 }];
    });
    setIsOpen(true);
  };

  const setQty = (slug, qty) => {
    if (qty <= 0) {
      setItems((prev) => prev.filter((i) => i.slug !== slug));
      return;
    }
    setItems((prev) => prev.map((i) => (i.slug === slug ? { ...i, qty } : i)));
  };

  const removeItem = (slug) => setItems((prev) => prev.filter((i) => i.slug !== slug));
  const clearCart = () => setItems([]);

  const detailed = useMemo(
    () =>
      items
        .map((i) => {
          const product = PRODUCTS.find((p) => p.slug === i.slug);
          return product ? { ...i, product } : null;
        })
        .filter(Boolean),
    [items]
  );

  const count = detailed.reduce((sum, i) => sum + i.qty, 0);
  const subtotal = detailed.reduce((sum, i) => sum + i.qty * i.product.price, 0);

  return (
    <CartContext.Provider
      value={{ items: detailed, count, subtotal, addItem, setQty, removeItem, clearCart, isOpen, setIsOpen }}
    >
      {children}
    </CartContext.Provider>
  );
};

export const useCart = () => useContext(CartContext);
